import { fetchFinance } from "utils/api";

export const queryList = async (params) => {
  if (params.key) {
    return await fetchFinance("/output/list", {
      key: `settlement/txt/${params.key}`,
    });
  } else {
    return await fetchFinance("/output/list", {
      key: "settlement/txt",
    });
  }
};

export const preSign = async (params) => {
  return await fetchFinance("/output/presign", {
    action: "get",
    ...params,
  });
};
